/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from "react";
import { ContainerComm } from "./container.com";
import { useViewport } from "@vlinder-web/viewport-provider-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

const MODULE_NAME = "LandingContainer";

const log: any = LoggerModule?.getInstance();

export const ProductLandingContainer = (props: any) => {
  const { bp, width } = useViewport();
  log.blue(MODULE_NAME, "bp: ", bp, "width: ", width);
  if (bp === "xs") {
    //Xtremely small device screen customization
  }
  if (bp === "sm") {
    //small device screen customization
  }
  if (bp === "md") {
    //medium device screen customization
  }
  if (bp === "lg") {
    //large device screen customization
  }
  return (
    <>
      <ContainerComm {...props} />
    </>
  );
};
